function gsbInitPriceSlider(priceRange) {
  if (priceRange.dataset.gsbInited) return;
  priceRange.dataset.gsbInited = '1';

  var maxRange = priceRange.querySelector('.gsb-range--max');
  var fill = priceRange.querySelector('.gsb-price-track__fill');

  // inputs[0]=hidden min, inputs[1]=visible max (Dawn's expected order)
  var textInputs = priceRange.querySelectorAll('input[name]');
  var maxText = textInputs[1] || textInputs[0] || null;

  if (!maxRange || !fill || !maxText) return;

  var sliderMax = Number(maxRange.max);

  function updateFill() {
    var pct = (Number(maxRange.value) / sliderMax) * 100;
    fill.style.left = '0%';
    fill.style.width = pct + '%';
  }

  // Live update while dragging
  maxRange.addEventListener('input', function () {
    maxText.value = maxRange.value;
    updateFill();
  });

  // On release: sync text and fire Dawn's form submission trigger
  maxRange.addEventListener('change', function () {
    maxText.value = maxRange.value;
    // Dawn's FacetFiltersForm listens for 'input' on the form to submit
    maxText.dispatchEvent(new Event('input', { bubbles: true }));
    updateFill();
  });

  // Sync range handle when user types in the To box
  maxText.addEventListener('input', function () {
    var v = Math.round(parseFloat(String(maxText.value).replace(/[^0-9.]/g, '')) || 0);
    if (v >= 0 && v <= sliderMax) {
      maxRange.value = v;
      updateFill();
    }
  });

  updateFill();
}

function gsbInitAllSliders() {
  document.querySelectorAll('price-range').forEach(gsbInitPriceSlider);
}

document.addEventListener('DOMContentLoaded', gsbInitAllSliders);

// Re-init after Dawn's facet AJAX re-renders
var gsbSliderObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (m) {
    m.addedNodes.forEach(function (node) {
      if (!node.querySelectorAll) return;
      if (node.tagName === 'PRICE-RANGE') gsbInitPriceSlider(node);
      node.querySelectorAll('price-range').forEach(gsbInitPriceSlider);
    });
  });
});
gsbSliderObserver.observe(document.body, { childList: true, subtree: true });
